import roomAPIService from "../../roomAPIService";
import sessionSocket from "../../../../socket/sessionSocket";
import store from "../../../../store";

/**
 * @TODO Could all be done in two functions: registerTimestamp and constructTimestamp, special success cases can be handled
 * by checking stamp type in case of success and taking relevant action. Also could be useful to define a constants file,
 * where each stamp type is written and re-used everywhere. And then all one would do is call registerTimeStamp(STAMP_CONSTANT)
 * and all would be taken care of.
 *
 * - This would make things more modular
 * - This would lead to less code (and not more complex code)
 * - This would make it easier to find *all* timestamp logic client-side as it would not be split between different functions.
 * Which would also make it easier to make changes down the line.
 */

function constructTimestamp(type, SID = null, UID = null, dateTimeMS = null) {
  const stampData = {
    SID: SID ? SID : store.state.session.sessionID,
    UID: UID ? UID : store.state.auth.user._id,
    stamp: Date.now(),
    type,
    dateTimeMS: dateTimeMS ? dateTimeMS : store.state.session.dateTimeMS,
  };
  if (type === "enter" || type === "join") {
    stampData.userData = navigator && navigator.userAgent ? navigator.userAgent : "";
    stampData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  return stampData;
}

/** @todo: update vuex 'has joined' state */
async function registerTimestamp(timestampData) {
  if (!timestampData || !timestampData.SID) return console.log("Missing data to register timestamp.");

  try {
    const resultData = await roomAPIService.addTimestamp(timestampData.SID, timestampData);
    console.log("@registerTimestamp resultData: ", resultData);
    if (!resultData.success) throw new Error("Failed to register timestamp.");
    return true;
  } catch (error) {
    console.error("@registerTimestamp error", error);
  }
  return false;
}

/* When a user enters the session, however does not necessarily
get past the loading screen due to some issue. */
export async function registerEnterTimestamp() {
  const timestampData = constructTimestamp("enter");
  await registerTimestamp(timestampData);
}

/* User has successfully connected to the session 
and has gotten past the loading screen. */
export async function registerJoinTimestamp() {
  const timestampData = constructTimestamp("join");
  const stampRegisterResult = await registerTimestamp(timestampData);
  if (stampRegisterResult) {
    store.dispatch("upcomingMatches/setUserAsJoined");
  }
}

/* When a user is stuck at the loading screen */
export async function registerStuckTimestamp() {
  const timestampData = constructTimestamp("stuck_at_loading");
  await registerTimestamp(timestampData);
  sessionSocket.emitUserStuckAtLoading();
}

/**
 * Creates and registers a timestamp for when a user
 * either turned their camera, mic or screensharing
 * on or off.
 *
 * @param {String} type — either 'cam_on', 'cam_off', 'mic_on',
 * 'mic_off', 'screen_on', screen_off'.
 */
export async function registerMediaStateChange(type) {
  const timestampData = constructTimestamp(type);
  await registerTimestamp(timestampData);
}

/**
 * Passes parameters because at this time, the session data may have already been reset,
 * therefore the data would *not* be available in the Vuex store during timestamp construction.
 *
 * @param {String} SID — Session ID
 * @param {String} UID — User ID
 * @param {Number} dateTimeMS — Session start time in milliseconds
 */
export async function registerLeaveTimestampOverHTTP(SID, UID, dateTimeMS) {
  const timestampData = constructTimestamp("leave", SID, UID, dateTimeMS);
  await registerTimestamp(timestampData);
}

export default {
  registerJoinTimestamp,
  registerEnterTimestamp,
  registerStuckTimestamp,
  registerMediaStateChange,
  registerLeaveTimestampOverHTTP,
};
